import axios from 'axios';
import properties from '../../properties';

export interface CohortMembersCountResponse {
  noOfMemberIds: number;
  member_unique_ids: string[];
}

export const getDeepDiveFilteredMembers = async (
  payload: any,
  identifier?: string,
  value?: any,
  key?: any,
): Promise<CohortMembersCountResponse> => {
  try {
    const response = await axios.post(
      properties.aiqBaseUrl +
        properties.deepDiveBaseUrl +
        properties.getDeepDiveFilteredMembers,
      {
        ...payload,
        selectedCategory: {
          identifier,
          value,
          key,
        },
      },
    );
    return response.data.data;
  } catch (error) {
    return {
      noOfMemberIds: 0,
      member_unique_ids: [],
    };
  }
};
